'use strict';
var EducationSubNavController = /** @class */ (function () {
    /*@ngInject*/
    function EducationSubNavController($state, EducationSubNavService) {
        this.isEducationLevel1 = function () {
            return this.pagetype == 'clinicalResources_l1' || this.pagetype == 'practiceManagement_l1';
        };
        this.isAuthenticatedClinicalResourcesPage = function () {
            return this.pagetype == 'clinicalResources_l1' && this.value.loggedInAs == 'Practitioner';
        };
        this.isAuthenticatedPractitionerPage = function () {
            return this.pagetype == 'practiceManagement_l1' && this.value.loggedInAs == 'Practitioner';
        };
        this.isAuthenticatedAsPatientOnClinicalResourcesPage = function () {
            return this.pagetype == 'clinicalResources_l1' && this.value.loggedInAs == 'Patient';
        };
        this.isAuthenticatedAsPatientOnPracticeMangementPage = function () {
            return this.pagetype == 'practiceManagement_l1' && this.value.loggedInAs == 'Patient';
        };
        this.isPracticeMangementPage = function () {
            return this.pagetype == 'practiceManagement_l1';
        };
        this.isClinicalResourcePage = function () {
            return this.pagetype == 'clinicalResources_l1';
        };
        this.$state = $state;
        this.eduSubNavService = EducationSubNavService;
        this.eduSubNavService.level = '1';
    }
    EducationSubNavController.prototype.changeLevel = function (levelVal) {
        this.eduSubNavService.level = levelVal;
    };
    return EducationSubNavController;
}());
export default EducationSubNavController;
//# sourceMappingURL=education-sub-nav.controller.js.map